import { LocaleLink } from "~/lib/components/link";
import cn from "classnames";
import { SkeletonItem } from "./SkeletonItem";
import { useState } from "react";
import { useTranslation } from "~/lib/utils/store/useTranslation";
import { BareButton } from "@setel/web-ui";

export type IListStyle = "borderTop" | "borderBottom";
interface IList<T> {
  isLoading: boolean;
  data?: {
    label: string;
    value: string;
  }[];
  numOfVisibleArticle?: number;
  isNumbering?: boolean;
  listStyle?: IListStyle;
  rightIcon?: React.ReactNode;
}

export const List = ({
  isLoading,
  data,
  numOfVisibleArticle,
  isNumbering = true,
  listStyle = "borderBottom",
  rightIcon,
}: IList<any>) => {
  const { t } = useTranslation();
  const [isShowAllData, setIsShowAllData] = useState(
    numOfVisibleArticle ? (data?.length || 0) <= numOfVisibleArticle : true
  );
  const visibleData = isShowAllData
    ? data
    : data?.slice(0, numOfVisibleArticle);

  if (isLoading) {
    return <SkeletonItem count={5} />;
  }

  return (
    <>
      {visibleData?.map((item, idx) => {
        return (
          <div key={item.value}>
            <LocaleLink
              to={item.value}
              className={cn(
                "flex flex-row items-start gap-4",
                listStyle === "borderBottom" && idx !== visibleData.length - 1
                  ? "border-b-[1px] border-white-off pb-4"
                  : "",
                listStyle === "borderBottom" && idx === 0 ? "pt-0" : "pt-4",
                listStyle === "borderTop" && idx !== visibleData.length
                  ? "border-t-[1px] border-white-off py-4"
                  : ""
              )}
            >
              {isNumbering && (
                <div className="font-secondary font-medium text-sm rounded-[20px] bg-gray-400 min-w-6 w-6 h-6 flex items-center justify-center">
                  {idx + 1}
                </div>
              )}
              <div className="flex-1 hover:text-brand hover:underline font-secondary font-normal text-[15px] leading-[21px] break-words">
                {item.label}
              </div>
              {rightIcon}
            </LocaleLink>
          </div>
        );
      })}
      {!isShowAllData && numOfVisibleArticle && data?.length && (
        <BareButton
          className={cn(
            "w-full text-brand font-medium text-sm pt-4 border-t border-gray-400 justify-start",
            listStyle === "borderBottom" ? "mt-4" : ""
          )}
          onClick={() => setIsShowAllData(true)}
        >
          {t("seeAllArticles", {
            count: data?.length - numOfVisibleArticle,
          })}
        </BareButton>
      )}
    </>
  );
};
